import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Space, Row, Col, DatePicker, Drawer, Table, Tag, Alert, Collapse, Modal } from 'antd';
import { ClockCircleOutlined, SaveOutlined, UserOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import moment from 'moment';
import {
    _newLine, CustomerScheduleType,
    isValidDateForm, ConvertCustomerScheduleStatus,
    isValidDate, ConvertCustomerScheduleType
} from '@/utils/helpers';

import { createCustomerSchedule, updateCustomerSchedule } from '@/redux/actions/CustomerScheduleActions';

const { Panel } = Collapse;

class CustomerScheduleForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            require_time: true,
            show_doctor: false,
            switch_status: false,
            show_time_to: false
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {
            if (nextProps?.currentItem?.name) {
                if (nextProps?.currentItem?.name == 'CHUADATDUOCLICH' ||
                    nextProps?.currentItem?.name == 'CHUAXACDINHLICH' ||
                    nextProps?.currentItem?.name == 'KHAC') {
                    this.setState({ require_time: false })
                    this.props.form.setFieldsValue({ time: null })
                } else {
                    this.setState({ require_time: true })
                }
                if (nextProps?.currentItem?.name == 'LAMDICHVU' || nextProps?.currentItem?.name == 'TAIKHAM') {
                    this.setState({ show_doctor: true })
                } else {
                    this.setState({ show_doctor: false })
                }
                if (nextProps?.currentItem?.name == 'GOILAI') {
                    this.setState({ switch_status: true })
                } else {
                    this.setState({ switch_status: false })
                }
                if (nextProps?.currentItem?.status == 'dagoi' || nextProps?.currentItem?.status == 'dangcho' || nextProps?.currentItem?.status == 'daden') {
                    this.setState({ show_time_to: true })
                } else {
                    this.setState({ show_time_to: false })
                }
            }
        }
    }

    async submit(e, forceCreate = false) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });

                try {
                    const { currentCustomer } = this.props;

                    values.time = values.time ? values.time.format("YYYY-MM-DD HH:mm") : null;
                    values.time_to = values.time_to ? values.time_to.format("YYYY-MM-DD HH:mm") : null;
                    values.start_time = values.start_time ? values.start_time.format("YYYY-MM-DD HH:mm") : null;

                    if (forceCreate) {
                        values.force_create = true;
                    }

                    if (this.props.currentItem) {
                        await this.props.updateCustomerSchedule(this.props.currentItem.id, values);
                    } else {
                        values.customer_id = currentCustomer.id;
                        values.status = this.state.switch_status ? 'chuagoi' : 'chuaden';
                        await this.props.createCustomerSchedule(values);
                    }

                    this.onClose();
                    this.props.reloadData();

                } catch (error) {
                    this.setState({ isLoading: false });

                    const res = error?.response;
                    const payload = res?.data?.data;

                    if (res?.status === 409 && payload?.need_confirm) {
                        this.showDuplicateConfirm(payload);
                        return;
                    }
                }
            }
        });
    }

    showDuplicateConfirm(payload) {
        const { existing_schedules, message } = payload;

        Modal.confirm({
            title: 'Lịch hẹn bị trùng cơ sở',
            okText: 'Vẫn cập nhật lịch',
            cancelText: 'Huỷ',
            bodyStyle: { padding: 15 },
            className: 'confirm-modal',
            content: (
                <>
                    <Alert style={{ fontSize: '1.1em' }} type="warning" message={message} className="mb-3 alert-text-red" />
                    <Table
                        rowKey="id"
                        size="small"
                        pagination={false}
                        dataSource={existing_schedules}
                        columns={[
                            {
                                title: 'Thời gian',
                                dataIndex: 'time',
                                render: t => moment(t).format('DD/MM/YYYY HH:mm')
                            },
                            {
                                title: 'Trạng thái',
                                dataIndex: 'status',
                                render: (text, record) => {
                                    return (
                                        <Space size="small">
                                            {ConvertCustomerScheduleType(record.name)}
                                            {ConvertCustomerScheduleStatus(record.status)}
                                        </Space>
                                    )
                                }
                            }
                        ]}
                    />
                </>
            ),
            onOk: () => this.submit({ preventDefault: () => { } }, true)
        });
    }

    onClose() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isLoading: false,
            show_doctor: false,
            require_time: true,
            switch_status: false,
            show_time_to: false
        });
    }

    changeName(value) {
        this.setState({
            require_time: value !== 'CHUADATDUOCLICH' && value !== 'CHUAXACDINHLICH',
            show_doctor: value === 'LAMDICHVU' || value === 'TAIKHAM',
            switch_status: value === 'GOILAI'
        }, () => {
            const { switch_status } = this.state;
            this.setState({ show_time_to: false })
            this.props.form.setFieldsValue({ status: switch_status ? 'chuagoi' : 'chuaden' });
        });

        if (value === 'CHUADATDUOCLICH' || value === 'CHUAXACDINHLICH') {
            this.props.form.setFieldsValue({ time: null });
        }
    }

    onChangeStatus(value) {
        this.setState({
            show_time_to: value === 'dagoi' || value === 'dangcho' || value === 'daden'
        });
    }

    render() {
        var { isLoading, require_time, show_doctor } = this.state;
        var { visible, currentItem, doctors, assistants, currentCustomer,
            filterReducer
        } = this.props;
        const { getFieldDecorator } = this.props.form;

        const branchActiveList = filterReducer.branches;

        const columns = [
            {
                title: 'Kiểu lịch hẹn',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    return (
                        <strong>
                            {ConvertCustomerScheduleType(record.name)}
                        </strong>
                    )
                }
            },
            {
                title: 'Thời gian',
                dataIndex: 'time',
                key: 'time',
                width: '140px',

                render: (text, record) => {
                    return (
                        <div>
                            {isValidDate(text)}
                        </div>
                    )
                }
            },
            {
                title: '#',
                width: '100px',
                render: (text, record) => {
                    var diffDate = record.time ? moment(record.time, "YYYY-MM-DD").diff(moment().startOf('day'), 'days') : 0;
                    return (
                        <div>
                            {
                                diffDate ? (
                                    <span>
                                        {
                                            diffDate > 0 ? <Tag color="#f50">Còn lại {diffDate} ngày</Tag> : <Tag color="red">Cách đây {-1 * diffDate} ngày</Tag>
                                        }
                                    </span>
                                ) : (
                                    <>
                                        {
                                            record.time != null ? (
                                                <Tag color="#096dd9">Hôm nay</Tag>
                                            ) : null
                                        }
                                    </>
                                )
                            }
                        </div>
                    )
                }
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                width: '100px',
                render: (text, record) => {
                    return (
                        <div>{ConvertCustomerScheduleStatus(text)}</div>
                    )
                }
            }
        ];

        const serviceOptions = (currentCustomer?.service_used || []).map(item => ({
            id: item.id,  // customer_service.id
            name: item.service?.name || '',
            code: item.service?.code || '',
        }));



        return (
            <Drawer
                visible={visible}
                title={`${currentItem ? "Sửa lịch hẹn" : "Tạo lịch hẹn"}`}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" size='large' onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.submit(e)}
                                size='large'
                                icon={<SaveOutlined />}
                            >
                                Lưu
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24} className='mb-3'>
                                <h6><UserOutlined /> Khách hàng:&nbsp;
                                    <span className='color-primary'>
                                        {(currentCustomer?.full_name || currentItem?.customer_name) + ' - ' + (currentCustomer?.code || currentItem?.customer_code)}
                                    </span>
                                </h6>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24} className='mb-3'>
                                <Alert
                                    message="Chú ý chọn đúng kiểu lịch hẹn"
                                    description={<>
                                        <p>- Lịch <strong>Điều trị:</strong> Khách vẫn đang trong quá trình thực hiện, chưa hoàn thành dịch vụ tại nha khoa.</p>
                                        <p>- Lịch <strong>Tái khám:</strong> Khách đã hoàn thành quá trình làm dịch vụ, hẹn tới thăm khám lại, kiểm tra định kỳ</p>
                                        <p>- Khi khách có nhu cầu thực hiện dịch vụ tại <strong>một cơ sở khác</strong> (khác với nơi đã đăng ký hồ sơ ban đầu), nhân viên cần chọn chính xác <strong>Cơ sở thực hiện dịch vụ</strong> tương ứng để hệ thống ghi nhận và phân phối lịch đúng nơi.</p>
                                    </>}
                                    type="warning"
                                />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Collapse
                                    bordered={false}
                                    defaultActiveKey={[]}
                                    className='mb-3'
                                    expandIconPosition="end"
                                >
                                    <Panel header={<span style={{ color: 'blue', fontWeight: 500 }}><ClockCircleOutlined /> Xem lịch sử cuộc hẹn</span>} key="1">
                                        <Table
                                            size='small'
                                            rowKey='key'
                                            tableLayout="auto"
                                            columns={columns}
                                            dataSource={currentCustomer?.appointments_timeline || currentItem?.appointments_timeline || []}
                                            pagination={false}
                                            loading={isLoading}
                                            scroll={isMobile ? { x: 'max-content' } : undefined}
                                            className='mb-4 w-100'
                                            locale={{ emptyText: "Chưa có dữ liệu" }}
                                        />
                                    </Panel>
                                </Collapse>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label='Kiểu lịch hẹn'>
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.name : null
                                    })(
                                        <BaseSelect
                                            options={CustomerScheduleType}
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                            onChange={(value) => this.changeName(value)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            {
                                require_time ? (
                                    <Col xs={24} md={12}>
                                        <Form.Item label="Giờ hẹn">
                                            {getFieldDecorator('time', {
                                                rules: [
                                                    {
                                                        required: require_time,
                                                        message: 'Vui lòng điền!',
                                                    },
                                                ],
                                                initialValue: currentItem ? isValidDateForm(currentItem.time) : ""
                                            })(
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    showTime={{ format: 'HH:mm', defaultValue: moment('00:00', 'HH:mm') }} // Giới hạn giờ và phút là 00:00
                                                    format="DD/MM/YYYY HH:mm"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                ) : null
                            }
                            {
                                show_doctor ? (
                                    <>
                                        <Col xs={24} md={24}>
                                            <Form.Item label="Bác sĩ thực hiện">
                                                {getFieldDecorator('doctor_ids', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng chọn!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.doctor_ids : []
                                                })(
                                                    <BaseSelect
                                                        options={doctors ?? []}
                                                        optionValue="user_id"
                                                        optionLabel="display_name"
                                                        placeholder="Chọn 1 hoặc nhiều bác sĩ"
                                                        defaultText="Chọn bác sĩ thực hiện"
                                                        showSearch={true}
                                                        mode="multiple"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={24}>
                                            <Form.Item label="Phụ tá">
                                                {getFieldDecorator('assistant_ids', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng chọn!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.assistant_ids : []
                                                })(
                                                    <BaseSelect
                                                        options={assistants ?? []}
                                                        optionValue="user_id"
                                                        optionLabel="display_name"
                                                        placeholder="Chọn 1 hoặc nhiều phụ tá"
                                                        defaultText="Chọn phụ tá"
                                                        showSearch={true}
                                                        mode="multiple"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={24}>
                                            <Form.Item label="Dịch vụ">
                                                {getFieldDecorator('customer_service_id', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng chọn!',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.customer_service_id : []
                                                })(
                                                    <BaseSelect
                                                        options={serviceOptions ?? []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        placeholder="Chọn 1 hoặc nhiều dịch vụ"
                                                        showSearch={true}
                                                        mode="multiple"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </>
                                ) : null
                            }
                            <Col xs={24} md={24}>
                                <Form.Item label="Cơ sở thực hiện dịch vụ">
                                    {getFieldDecorator('branch_ids', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.branch_ids : currentCustomer?.branch_id || null,
                                    })(
                                        <BaseSelect
                                            options={branchActiveList || []}
                                            optionValue="id"
                                            optionLabel="name"
                                            placeholder="Chọn một hoặc nhiều cơ sở"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : ""
                                    })(
                                        <Input.TextArea rows={4} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        doctors: state.config.doctors,
        assistants: state.config.assistants,
        filterReducer: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createCustomerSchedule: (data) => dispatch(createCustomerSchedule(data)),
        updateCustomerSchedule: (id, data) => dispatch(updateCustomerSchedule(id, data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerScheduleForm' })(CustomerScheduleForm));
